module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "发放权益卡",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "dataForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员用户"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "支持手机号与昵称模糊搜索",
      "remote-method": _vm.loadMemberUsers,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.memberIds),
      callback: function($$v) {
        _vm.memberIds = $$v
      },
      expression: "memberIds"
    }
  }, _vm._l((_vm.memberUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nickname + '（' + item.phoneNo + '）',
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleGrant
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-4f034ed9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/card/components/grant.vue
// module id = 1666
// module chunks = 0